import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=085dad4a&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=085dad4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085dad4a",
  null
  
)

export default component.exports